// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__[local]___LHumM"};